// import React, { useState, useEffect } from 'react';
// import { Shuffle, Save, CheckCircle, AlertCircle, RefreshCw, Filter, LayoutGrid, Users, CheckSquare, Square, Trash2 } from 'lucide-react';
// import apiService from '../../config';

// const PlotLuckyDraw = () => {
//     const [currentProjectId, setCurrentProjectId] = useState(null);
//     const [currentProposalId, setCurrentProposalId] = useState(null);

//     // Data States
//     const [allOwners, setAllOwners] = useState([]);
//     const [allPlots, setAllPlots] = useState([]);
//     const [allocations, setAllocations] = useState([]);
    
//     // UI States
//     const [activeArea, setActiveArea] = useState(370);
//     const [loading, setLoading] = useState(true);
//     const [isDrawing, setIsDrawing] = useState(false);
//     const [isSaving, setIsSaving] = useState(false);
//     const [saveStatus, setSaveStatus] = useState(null);
    
//     // Selection State
//     const [selectedPlotIds, setSelectedPlotIds] = useState([]);

//     // Initialize Project & Proposal IDs
//     useEffect(() => {
//         const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
//         const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        
//         setCurrentProjectId(selectedProject.project_id || selectedProject.id || userData.data?.project_id);
//         setCurrentProposalId(userData?.default_proposal || userData.data?.proposal_id);
//     }, []);

//     // Fetch Both APIs
//     useEffect(() => {
//         if (currentProjectId && currentProposalId) {
//             fetchData();
//         }
//     }, [currentProjectId, currentProposalId]);

//     const fetchData = async () => {
//         try {
//             setLoading(true);
            
//             const familyRes = await apiService.getFamilyDetails(currentProjectId, currentProposalId);
//             const plotsRes = await apiService.getRehabA(currentProjectId, currentProposalId);
//             const plotsData = plotsRes || [];

//             const alreadyAssignedOwnerNames = plotsData
//                 .filter(p => p.owner_name && p.owner_name.trim() !== '')
//                 .map(p => p.owner_name.trim());

//             const processedOwners = (familyRes || [])
//                 .map(owner => {
//                     const familyCount = owner.familyDetails ? owner.familyDetails.length : 1;
//                     let requiredArea = 370;
                    
//                     if (familyCount >= 1 && familyCount <= 5) requiredArea = 370;
//                     else if (familyCount >= 6 && familyCount <= 8) requiredArea = 555;
//                     else if (familyCount >= 9) requiredArea = 740;

//                     return {
//                         land_owner_id: owner.land_owner_id,
//                         owner_name: owner.owner_name,
//                         familyCount: familyCount,
//                         requiredArea: requiredArea
//                     };
//                 })
//                 .filter(owner => !alreadyAssignedOwnerNames.includes(owner.owner_name?.trim()));

//             setAllOwners(processedOwners);
//             setAllPlots(plotsData);
//             setAllocations([]); 
//             setSelectedPlotIds([]); 
            
//         } catch (error) {
//             console.error('Error fetching data:', error);
//             alert('माहिती लोड करताना त्रुटी आली.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Reset UI states when switching tabs
//     useEffect(() => {
//         setSaveStatus(null);
//         setSelectedPlotIds([]);
//     }, [activeArea]);

//     // Derived Data for the ACTIVE AREA
//     const currentAreaOwners = allOwners.filter(o => o.requiredArea === activeArea);
//     const allPlotsForActiveArea = allPlots.filter(p => Math.round(Number(p.area_sq_mtr)) === activeArea);
//     const currentAreaPlots = allPlotsForActiveArea.filter(p => !p.owner_name || p.owner_name.trim() === '');
//     const currentAreaAllocations = allocations.filter(a => a.requiredArea === activeArea);
//     const isDrawActive = currentAreaAllocations.length > 0;

//     // --- Plot Selection Logic ---
//     const togglePlotSelection = (id) => {
//         if (isDrawActive) return; 
//         setSelectedPlotIds(prev => 
//             prev.includes(id) ? prev.filter(pid => pid !== id) : [...prev, id]
//         );
//     };

//     const handleSelectAll = () => {
//         if (isDrawActive) return;
//         const allUnassignedIds = currentAreaPlots.map(p => p.rehab_id);
//         setSelectedPlotIds(allUnassignedIds);
//     };

//     const handleClearSelection = () => {
//         if (isDrawActive) return;
//         setSelectedPlotIds([]);
//     };

//     // --- Core Lucky Draw Logic ---
//     const runLuckyDraw = () => {
//         // STRICT CHECK: Double-checking before running
//         if (selectedPlotIds.length < currentAreaOwners.length) {
//             alert("कृपया सर्व लाभार्थींसाठी पुरेसे भूखंड निवडा.");
//             return;
//         }

//         setIsDrawing(true);
//         setSaveStatus(null);

//         setTimeout(() => {
//             let availablePlotsForArea = currentAreaPlots.filter(p => selectedPlotIds.includes(p.rehab_id));
//             let newAreaAllocations = [];

//             const shuffledOwners = [...currentAreaOwners].sort(() => 0.5 - Math.random());

//             shuffledOwners.forEach(owner => {
//                 if (availablePlotsForArea.length > 0) {
//                     const randomIndex = Math.floor(Math.random() * availablePlotsForArea.length);
//                     const selectedPlot = availablePlotsForArea[randomIndex];

//                     newAreaAllocations.push({
//                         ...owner,
//                         assignedPlot: selectedPlot,
//                         status: 'Success'
//                     });

//                     availablePlotsForArea = availablePlotsForArea.filter(p => p.rehab_id !== selectedPlot.rehab_id);
//                 } else {
//                     newAreaAllocations.push({
//                         ...owner,
//                         assignedPlot: null,
//                         status: 'No Plot Available'
//                     });
//                 }
//             });

//             newAreaAllocations.sort((a, b) => a.owner_name.localeCompare(b.owner_name));
            
//             setAllocations(prev => {
//                 const otherAreas = prev.filter(a => a.requiredArea !== activeArea);
//                 return [...otherAreas, ...newAreaAllocations];
//             });
            
//             setIsDrawing(false);
//         }, 800);
//     };

//     const clearCurrentDraw = () => {
//         setAllocations(prev => prev.filter(a => a.requiredArea !== activeArea));
//         setSaveStatus(null);
//     };

//     // --- Save Logic ---
//     const handleSaveAllocations = async () => {
//         const successfulAllocations = currentAreaAllocations.filter(a => a.assignedPlot);
        
//         if (successfulAllocations.length === 0) {
//             alert('सेव्ह करण्यासाठी कोणतेही भूखंड नाहीत.');
//             return;
//         }

//         if (!window.confirm(`तुम्ही ${activeArea} चौ.मी. चे ${successfulAllocations.length} वाटप जतन करू इच्छिता?`)) {
//             return;
//         }

//         setIsSaving(true);
//         try {
//             await Promise.all(
//                 successfulAllocations.map(alloc => {
//                     const payload = {
//                         owner_name: alloc.owner_name,
//                         // land_owner_id: alloc.land_owner_id 
//                     };
//                     return apiService.patchUpdateRehabA(alloc.assignedPlot.rehab_id, payload);
//                 })
//             );
            
//             setSaveStatus('success');
//             await fetchData(); 
            
//         } catch (error) {
//             console.error('Error saving allocations:', error);
//             setSaveStatus('error');
//             alert('वाटप जतन करताना त्रुटी आली.');
//         } finally {
//             setIsSaving(false);
//         }
//     };

//     // Sort plots logically
//     const sortedPlotsForGrid = [...allPlotsForActiveArea].sort((a, b) => {
//         return a.plot_no.toString().localeCompare(b.plot_no.toString(), undefined, { numeric: true, sensitivity: 'base' });
//     });

//     if (loading) return <div className="text-center p-10 font-bold text-gray-600 animate-pulse">माहिती लोड होत आहे...</div>;

//     // Validation Boolean for the Draw Button
//     const hasEnoughPlotsSelected = selectedPlotIds.length >= currentAreaOwners.length;

//     return (
//         <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
//             <h1 className="text-2xl font-bold mb-6 text-gray-800">लकी ड्रॉ (Area-Wise Allocation)</h1>

//             {/* Area Selection Tabs */}
//             <div className="flex flex-wrap items-center gap-4 bg-white p-4 rounded-xl shadow-sm border mb-6">
//                 <div className="flex items-center gap-2 text-gray-600 font-bold mr-4">
//                     <Filter size={20} className="text-blue-600" />
//                     क्षेत्रफळ निवडा:
//                 </div>
//                 {[370, 555, 740].map((area) => (
//                     <button
//                         key={area}
//                         onClick={() => setActiveArea(area)}
//                         className={`px-6 py-2 rounded-lg font-bold transition-all ${
//                             activeArea === area 
//                             ? 'bg-blue-600 text-white shadow-md transform scale-105' 
//                             : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                         }`}
//                     >
//                         {area} चौ.मी.
//                     </button>
//                 ))}
//             </div>

//             {/* Dashboard Summary for ACTIVE AREA */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
//                 <div className="bg-white p-5 rounded-xl shadow border-l-4 border-orange-500 flex flex-col justify-center">
//                     <h3 className="text-sm text-gray-500 font-medium">पात्र लाभार्थी (Eligible Owners)</h3>
//                     <div className="text-3xl font-black text-orange-600 mt-1">{currentAreaOwners.length}</div>
//                 </div>
//                 <div className="bg-white p-5 rounded-xl shadow border-l-4 border-green-500 flex flex-col justify-center">
//                     <h3 className="text-sm text-gray-500 font-medium">एकूण रिक्त भूखंड (Available)</h3>
//                     <div className="text-3xl font-black text-green-600 mt-1">{currentAreaPlots.length}</div>
//                 </div>
//                 <div className={`p-5 rounded-xl shadow border-l-4 flex flex-col justify-center ${hasEnoughPlotsSelected ? 'bg-blue-50 border-blue-600' : 'bg-red-50 border-red-500'}`}>
//                     <h3 className={`text-sm font-bold ${hasEnoughPlotsSelected ? 'text-blue-700' : 'text-red-700'}`}>ड्रॉ साठी निवडलेले भूखंड</h3>
//                     <div className={`text-3xl font-black mt-1 ${hasEnoughPlotsSelected ? 'text-blue-800' : 'text-red-600'}`}>
//                         {selectedPlotIds.length} <span className={`text-lg font-medium ${hasEnoughPlotsSelected ? 'text-blue-600' : 'text-red-400'}`}>/ {currentAreaPlots.length}</span>
//                     </div>
//                 </div>
//             </div>

//             {/* STRICT VALIDATION ALERT */}
//             {!hasEnoughPlotsSelected && currentAreaOwners.length > 0 && !isDrawActive && (
//                 <div className="bg-red-100 border border-red-300 text-red-800 px-4 py-3 rounded-lg mb-6 flex items-center gap-2 font-medium">
//                     <AlertCircle size={20} className="text-red-600" /> 
//                     सूचना: ड्रॉ सुरू करण्यासाठी तुम्हाला किमान {currentAreaOwners.length} भूखंड निवडणे आवश्यक आहे. (सध्या फक्त {selectedPlotIds.length} निवडले आहेत).
//                 </div>
//             )}

//             {saveStatus === 'success' && (
//                 <div className="bg-green-100 border border-green-400 text-green-800 px-4 py-3 rounded-lg mb-6 flex items-center gap-2 font-medium shadow-sm">
//                     <CheckCircle /> {activeArea} चौ.मी. चे भूखंड यशस्वीरीत्या जतन केले! ग्रिड मध्ये तपासा.
//                 </div>
//             )}

//             {/* VISUAL PLOT GRID */}
//             <div className="bg-white rounded-xl shadow-sm border p-6 mb-8">
//                 <div className="flex flex-wrap items-center justify-between gap-4 mb-6 border-b pb-4">
//                     <div className="flex items-center gap-2">
//                         <LayoutGrid size={24} className="text-gray-700" />
//                         <h2 className="text-xl font-bold text-gray-800">भूखंड स्थिती ग्रिड ({activeArea} चौ.मी.)</h2>
//                     </div>
                    
//                     {!isDrawActive && currentAreaPlots.length > 0 && (
//                         <div className="flex gap-2">
//                             <button onClick={handleSelectAll} className="flex items-center gap-1 text-sm bg-gray-100 hover:bg-gray-200 px-3 py-1.5 rounded font-medium text-gray-700 border">
//                                 <CheckSquare size={16} /> सर्व निवडा
//                             </button>
//                             <button onClick={handleClearSelection} className="flex items-center gap-1 text-sm bg-gray-100 hover:bg-gray-200 px-3 py-1.5 rounded font-medium text-gray-700 border">
//                                 <Square size={16} /> निवड रद्द करा
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 {/* Legend */}
//                 <div className="flex flex-wrap gap-4 mb-6 text-sm font-medium">
//                     <div className="flex items-center gap-2"><div className="w-4 h-4 rounded bg-gray-50 border border-gray-300"></div> रिक्त (क्लिक करून निवडा)</div>
//                     <div className="flex items-center gap-2"><div className="w-4 h-4 rounded bg-blue-100 border border-blue-500"></div> ड्रॉ साठी निवडले</div>
//                     <div className="flex items-center gap-2"><div className="w-4 h-4 rounded bg-yellow-100 border border-yellow-400"></div> ड्रॉ पूर्ण (Pending Save)</div>
//                     <div className="flex items-center gap-2"><div className="w-4 h-4 rounded bg-green-100 border border-green-500"></div> वाटप झाले (Saved)</div>
//                 </div>

//                 <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
//                     {sortedPlotsForGrid.map(plot => {
//                         const pendingAllocation = currentAreaAllocations.find(a => a.assignedPlot?.rehab_id === plot.rehab_id);
//                         const isSelected = selectedPlotIds.includes(plot.rehab_id);
                        
//                         let bgClass = "bg-gray-50 border-gray-300 text-gray-500 cursor-pointer hover:bg-gray-200";
//                         let statusText = "रिक्त (निवडा)";
//                         let displayOwner = "";
//                         let isSelectable = true;

//                         if (plot.owner_name && plot.owner_name.trim() !== '') {
//                             bgClass = "bg-green-50 border-green-500 text-green-800 shadow-sm opacity-80 cursor-not-allowed";
//                             statusText = "वाटप झाले";
//                             displayOwner = plot.owner_name;
//                             isSelectable = false;
//                         } else if (pendingAllocation) {
//                             bgClass = "bg-yellow-50 border-yellow-400 text-yellow-800 shadow-sm ring-2 ring-yellow-200 cursor-not-allowed";
//                             statusText = "Pending Save";
//                             displayOwner = pendingAllocation.owner_name;
//                             isSelectable = false;
//                         } else if (isSelected) {
//                             bgClass = "bg-blue-50 border-blue-500 text-blue-800 shadow-md cursor-pointer hover:bg-blue-100 ring-2 ring-blue-200";
//                             statusText = "ड्रॉ साठी निवडले";
//                         }

//                         const handlePlotClick = () => {
//                             if (isSelectable && !isDrawActive) {
//                                 togglePlotSelection(plot.rehab_id);
//                             }
//                         };

//                         return (
//                             <div 
//                                 key={plot.rehab_id} 
//                                 onClick={handlePlotClick}
//                                 className={`border-2 rounded-xl p-3 flex flex-col items-center justify-center text-center transition-all min-h-[100px] ${bgClass}`}
//                             >
//                                 <span className="text-[10px] font-bold uppercase tracking-wider opacity-70 mb-1">{statusText}</span>
//                                 <span className="text-2xl font-black mb-1">क्र. {plot.plot_no}</span>
//                                 <span className="text-xs font-bold leading-tight break-words w-full px-1">{displayOwner}</span>
//                             </div>
//                         );
//                     })}
                    
//                     {sortedPlotsForGrid.length === 0 && (
//                         <div className="col-span-full text-center text-gray-400 py-8">
//                             या क्षेत्राचे कोणतेही भूखंड उपलब्ध नाहीत.
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {/* Actions for Draw */}
//             <div className="flex flex-wrap gap-4 mb-6 bg-white p-4 rounded-xl shadow-sm border items-center justify-between  bottom-4 z-10">
//                 <div className="flex gap-4 items-center">
//                     <button
//                         onClick={runLuckyDraw}
//                         // UPDATED: disabled if selected plots are less than owners
//                         disabled={isDrawing || currentAreaOwners.length === 0 || !hasEnoughPlotsSelected || isDrawActive}
//                         className={`flex items-center gap-2 px-8 py-3 rounded-lg font-bold shadow-lg transition-all text-lg
//                             ${!hasEnoughPlotsSelected && !isDrawActive ? 'bg-gray-400 text-gray-200 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
//                     >
//                         {isDrawing ? <RefreshCw className="animate-spin" size={24} /> : <Shuffle size={24} />}
//                         लकी ड्रॉ सुरु करा ({selectedPlotIds.length} भूखंड)
//                     </button>

//                     {isDrawActive && (
//                         <button
//                             onClick={clearCurrentDraw}
//                             disabled={isSaving}
//                             className="flex items-center gap-2 text-red-600 border border-red-200 bg-red-50 px-4 py-3 rounded-lg font-bold hover:bg-red-100 transition-all"
//                         >
//                             <Trash2 size={20} /> ड्रॉ रद्द करा (Reset)
//                         </button>
//                     )}
//                 </div>

//                 {isDrawActive && (
//                     <button
//                         onClick={handleSaveAllocations}
//                         disabled={isSaving}
//                         className="flex items-center gap-2 bg-green-600 text-white px-8 py-3 rounded-lg font-bold shadow-lg hover:bg-green-700 disabled:opacity-50 transition-all text-lg animate-pulse"
//                     >
//                         {isSaving ? <RefreshCw className="animate-spin" size={24} /> : <Save size={24} />}
//                         {isSaving ? 'जतन करत आहे...' : 'वाटप जतन करा (Save All)'}
//                     </button>
//                 )}
//             </div>

//             {/* PRE-DRAW STATE: Show eligible owners */}
//             {!isDrawActive && currentAreaOwners.length > 0 && !loading && (
//                 <div className="bg-white rounded-xl shadow overflow-hidden border mb-8">
//                     <div className="bg-blue-50 p-4 border-b flex items-center gap-2">
//                         <Users size={20} className="text-blue-700" />
//                         <h2 className="text-lg font-bold text-blue-900">लकी ड्रॉसाठी पात्र लाभार्थी (Eligible Owners)</h2>
//                     </div>
//                     <table className="w-full text-left border-collapse">
//                         <thead>
//                             <tr className="bg-gray-100 border-b text-sm">
//                                 <th className="p-4 font-semibold text-gray-700">लाभार्थीचे नाव</th>
//                                 <th className="p-4 font-semibold text-gray-700 text-center w-32">कुटुंब संख्या</th>
//                                 <th className="p-4 font-semibold text-gray-700 text-center w-40">पात्र क्षेत्रफळ</th>
//                                 <th className="p-4 font-semibold text-gray-700 text-center w-48">स्थिती</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentAreaOwners.map((owner, idx) => (
//                                 <tr key={owner.land_owner_id} className={`border-b ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50 hover:bg-gray-100'}`}>
//                                     <td className="p-4 font-medium text-gray-800">{owner.owner_name}</td>
//                                     <td className="p-4 text-center text-gray-600">{owner.familyCount}</td>
//                                     <td className="p-4 text-center text-gray-600">{owner.requiredArea} चौ.मी.</td>
//                                     <td className="p-4 flex justify-center">
//                                         <span className="text-gray-400 text-sm font-medium animate-pulse">ड्रॉ ची प्रतीक्षा...</span>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             )}

//             {/* Empty States (No owners to draw) */}
//             {currentAreaOwners.length === 0 && !loading && (
//                 <div className="text-center p-10 bg-white rounded-xl shadow text-gray-500 mb-8 border">
//                     या क्षेत्रासाठी ({activeArea} चौ.मी.) कोणतेही पात्र लाभार्थी शिल्लक नाहीत.
//                 </div>
//             )}

//             {/* POST-DRAW STATE: Results Table */}
//             {isDrawActive && (
//                 <div className="bg-white rounded-xl shadow overflow-hidden border mb-8 border-green-200">
//                     <div className="bg-green-50 p-4 border-b border-green-200">
//                         <h2 className="text-lg font-bold text-green-900">नुकतेच काढलेले ड्रॉ (Current Draw Results) - सेव्ह करणे बाकी आहे</h2>
//                     </div>
//                     <table className="w-full text-left border-collapse">
//                         <thead>
//                             <tr className="bg-gray-100 border-b text-sm">
//                                 <th className="p-4 font-semibold text-gray-700">लाभार्थीचे नाव</th>
//                                 <th className="p-4 font-semibold text-gray-700 text-center w-32">कुटुंब संख्या</th>
//                                 <th className="p-4 font-semibold text-gray-700 text-center w-40">वाटप केलेला भूखंड</th>
//                                 <th className="p-4 font-semibold text-gray-700 text-center w-48">स्थिती (Status)</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentAreaAllocations.map((alloc, idx) => (
//                                 <tr key={alloc.land_owner_id} className={`border-b ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50 hover:bg-gray-100'}`}>
//                                     <td className="p-4 font-medium text-gray-800">{alloc.owner_name}</td>
//                                     <td className="p-4 text-center text-gray-600">{alloc.familyCount}</td>
//                                     <td className="p-4 text-center font-black text-xl text-blue-700">
//                                         {alloc.assignedPlot ? alloc.assignedPlot.plot_no : <span className="text-red-400 text-sm">शिल्लक नाही</span>}
//                                     </td>
//                                     <td className="p-4 flex justify-center">
//                                         {alloc.assignedPlot ? (
//                                             <div className="flex items-center gap-1 text-green-700 bg-green-100 border border-green-200 px-3 py-1.5 rounded-full text-xs font-bold">
//                                                 <CheckCircle size={14} /> यशस्वी
//                                             </div>
//                                         ) : (
//                                             <div className="flex items-center gap-1 text-red-700 bg-red-100 border border-red-200 px-3 py-1.5 rounded-full text-xs font-bold">
//                                                 <AlertCircle size={14} /> भूखंड उपलब्ध नाही
//                                             </div>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default PlotLuckyDraw;

import React, { useState, useEffect } from 'react';
import { Shuffle, Save, CheckCircle, AlertCircle, RefreshCw, Filter, LayoutGrid, Users, CheckSquare, Square, Trash2, Tag } from 'lucide-react';
import apiService from '../../config';

const PlotLuckyDraw = () => {
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);

    // Data States
    const [allOwners, setAllOwners] = useState([]);
    const [allPlots, setAllPlots] = useState([]);
    const [allocations, setAllocations] = useState([]);
    
    // UI States
    const [activeArea, setActiveArea] = useState(370);
    const [loading, setLoading] = useState(true);
    const [isDrawing, setIsDrawing] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [saveStatus, setSaveStatus] = useState(null);
    
    // Selection State
    const [selectedPlotIds, setSelectedPlotIds] = useState([]);

    useEffect(() => {
        const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        setCurrentProjectId(selectedProject.project_id || selectedProject.id || userData.data?.project_id);
        setCurrentProposalId(userData.default_proposal || userData.data?.proposal_id);
    }, []);

    useEffect(() => {
        if (currentProjectId && currentProposalId) {
            fetchData();
        }
    }, [currentProjectId, currentProposalId]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const familyRes = await apiService.getFamilyDetails(currentProjectId, currentProposalId);
            const plotsRes = await apiService.getRehabA(currentProjectId, currentProposalId);
            const plotsData = plotsRes || [];

            const alreadyAssignedOwnerNames = plotsData
                .filter(p => p.owner_name && p.owner_name.trim() !== '')
                .map(p => p.owner_name.trim());

            const processedOwners = (familyRes || [])
                .map(owner => {
                    const familyCount = owner.familyDetails ? owner.familyDetails.length : 1;
                    const classification = owner.Family_11_1_classification; 
                    
                    let requiredArea = 0;

                    // UPDATED LOGIC FOR CLASSIFICATION
                    if (classification === "खातेदार") {
                        if (familyCount >= 1 && familyCount <= 5) requiredArea = 370;
                        else if (familyCount >= 6 && familyCount <= 8) requiredArea = 555;
                        else if (familyCount >= 9) requiredArea = 740;
                    } else if (classification === "विगर खातेदार") {
                        if (familyCount >= 1 && familyCount <= 5) requiredArea = 185;
                        else if (familyCount >= 6 && familyCount <= 8) requiredArea = 277;
                        else if (familyCount >= 9) requiredArea = 370;
                    }

                    return {
                        land_owner_id: owner.land_owner_id,
                        owner_name: owner.owner_name,
                        familyCount: familyCount,
                        classification: classification || "N/A",
                        requiredArea: requiredArea
                    };
                })
                .filter(owner => !alreadyAssignedOwnerNames.includes(owner.owner_name?.trim()) && owner.requiredArea > 0);

            setAllOwners(processedOwners);
            setAllPlots(plotsData);
            setAllocations([]); 
            setSelectedPlotIds([]); 
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setSaveStatus(null);
        setSelectedPlotIds([]);
    }, [activeArea]);

    const currentAreaOwners = allOwners.filter(o => o.requiredArea === activeArea);
    const allPlotsForActiveArea = allPlots.filter(p => Math.round(Number(p.area_sq_mtr)) === activeArea);
    const currentAreaPlots = allPlotsForActiveArea.filter(p => !p.owner_name || p.owner_name.trim() === '');
    const currentAreaAllocations = allocations.filter(a => a.requiredArea === activeArea);
    const isDrawActive = currentAreaAllocations.length > 0;

    const togglePlotSelection = (id) => {
        if (isDrawActive) return; 
        setSelectedPlotIds(prev => prev.includes(id) ? prev.filter(pid => pid !== id) : [...prev, id]);
    };

    const runLuckyDraw = () => {
        if (selectedPlotIds.length < currentAreaOwners.length) {
            alert("पुरेसे भूखंड निवडलेले नाहीत.");
            return;
        }
        setIsDrawing(true);
        setTimeout(() => {
            let availablePlots = currentAreaPlots.filter(p => selectedPlotIds.includes(p.rehab_id));
            let newAllocations = [];
            const shuffledOwners = [...currentAreaOwners].sort(() => 0.5 - Math.random());

            shuffledOwners.forEach(owner => {
                if (availablePlots.length > 0) {
                    const randomIndex = Math.floor(Math.random() * availablePlots.length);
                    const selectedPlot = availablePlots[randomIndex];
                    newAllocations.push({ ...owner, assignedPlot: selectedPlot });
                    availablePlots = availablePlots.filter(p => p.rehab_id !== selectedPlot.rehab_id);
                }
            });
            setAllocations(prev => [...prev.filter(a => a.requiredArea !== activeArea), ...newAllocations]);
            setIsDrawing(false);
        }, 800);
    };

    const handleSaveAllocations = async () => {
        setIsSaving(true);
        try {
            await Promise.all(currentAreaAllocations.map(alloc => 
                apiService.patchUpdateRehabA(alloc.assignedPlot.rehab_id, { owner_name: alloc.owner_name })
            ));
            setSaveStatus('success');
            await fetchData(); 
        } catch (error) {
            alert('त्रुटी आली.');
        } finally {
            setIsSaving(false);
        }
    };

    const sortedPlotsForGrid = [...allPlotsForActiveArea].sort((a, b) => 
        a.plot_no.toString().localeCompare(b.plot_no.toString(), undefined, { numeric: true })
    );

    const hasEnoughPlotsSelected = selectedPlotIds.length >= currentAreaOwners.length;

    return (
        <div className="max-w-6xl mx-auto p-6 bg-gray-50 min-h-screen">
            <h1 className="text-2xl font-bold mb-6 text-gray-800">लकी ड्रॉ (वर्गीकरणानुसार)</h1>

            {/* Area Tabs */}
            <div className="flex flex-wrap items-center gap-2 bg-white p-3 rounded-xl shadow-sm border mb-6">
                <span className="font-bold text-gray-600 px-2 flex items-center gap-1"><Filter size={18}/> क्षेत्रफळ:</span>
                {[185, 277, 370, 555, 740].map((area) => (
                    <button
                        key={area}
                        onClick={() => setActiveArea(area)}
                        className={`px-4 py-2 rounded-lg font-bold transition-all ${activeArea === area ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
                    >
                        {area}
                    </button>
                ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="bg-white p-5 rounded-xl shadow border-l-4 border-orange-500">
                    <p className="text-xs font-bold text-gray-400 uppercase">पात्र लाभार्थी</p>
                    <p className="text-3xl font-black text-orange-600">{currentAreaOwners.length}</p>
                </div>
                <div className="bg-white p-5 rounded-xl shadow border-l-4 border-green-500">
                    <p className="text-xs font-bold text-gray-400 uppercase">रिक्त भूखंड</p>
                    <p className="text-3xl font-black text-green-600">{currentAreaPlots.length}</p>
                </div>
                <div className={`p-5 rounded-xl shadow border-l-4 ${hasEnoughPlotsSelected ? 'bg-blue-50 border-blue-600' : 'bg-red-50 border-red-500'}`}>
                    <p className="text-xs font-bold uppercase">निवडलेले भूखंड</p>
                    <p className={`text-3xl font-black ${hasEnoughPlotsSelected ? 'text-blue-800' : 'text-red-600'}`}>{selectedPlotIds.length} / {currentAreaPlots.length}</p>
                </div>
            </div>

            {!hasEnoughPlotsSelected && currentAreaOwners.length > 0 && !isDrawActive && (
                <div className="bg-red-100 border border-red-300 text-red-800 p-3 rounded-lg mb-6 flex items-center gap-2 font-medium">
                    <AlertCircle size={18} /> ड्रॉ साठी किमान {currentAreaOwners.length} भूखंड निवडा.
                </div>
            )}

            {/* Plot Grid */}
            <div className="bg-white rounded-xl shadow-sm border p-6 mb-8">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-bold flex items-center gap-2"><LayoutGrid size={20}/> भूखंड ग्रिड ({activeArea})</h2>
                    {!isDrawActive && <div className="flex gap-2">
                        <button onClick={() => setSelectedPlotIds(currentAreaPlots.map(p => p.rehab_id))} className="text-xs bg-gray-100 px-3 py-1.5 rounded border font-bold">सर्व निवडा</button>
                        <button onClick={() => setSelectedPlotIds([])} className="text-xs bg-gray-100 px-3 py-1.5 rounded border font-bold">रद्द करा</button>
                    </div>}
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
                    {sortedPlotsForGrid.map(plot => {
                        const pending = currentAreaAllocations.find(a => a.assignedPlot?.rehab_id === plot.rehab_id);
                        const isSelected = selectedPlotIds.includes(plot.rehab_id);
                        let bg = "bg-gray-50 border-gray-200 text-gray-300";
                        if (plot.owner_name) bg = "bg-green-100 border-green-500 text-green-800";
                        else if (pending) bg = "bg-yellow-100 border-yellow-500 text-yellow-800 scale-95 ring-2 ring-yellow-400";
                        else if (isSelected) bg = "bg-blue-100 border-blue-600 text-blue-800 ring-2 ring-blue-400";

                        return (
                            <div key={plot.rehab_id} onClick={() => !plot.owner_name && !isDrawActive && togglePlotSelection(plot.rehab_id)} className={`border-2 rounded-xl p-3 text-center transition-all cursor-pointer ${bg}`}>
                                <div className="text-xl font-black">क्र. {plot.plot_no}</div>
                                <div className="text-[10px] font-bold truncate mt-1">{pending ? pending.owner_name : (plot.owner_name || 'रिकामी')}</div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* PRE-DRAW OWNERS TABLE */}
            {!isDrawActive && currentAreaOwners.length > 0 && (
                <div className="bg-white rounded-xl shadow-sm border overflow-hidden mb-8">
                    <div className="bg-gray-50 p-4 border-b flex items-center gap-2 font-bold text-gray-700">
                        <Users size={20} /> पात्र लाभार्थी यादी ({activeArea} चौ.मी.)
                    </div>
                    <table className="w-full text-left">
                        <thead className="bg-gray-100 text-gray-600 text-xs uppercase">
                            <tr>
                                <th className="p-4">नाव</th>
                                <th className="p-4 text-center">वर्गीकरण</th>
                                <th className="p-4 text-center">कुटुंब संख्या</th>
                                <th className="p-4 text-center">स्थिती</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {currentAreaOwners.map((owner) => (
                                <tr key={owner.land_owner_id} className="hover:bg-gray-50 transition-colors">
                                    <td className="p-4 font-semibold">{owner.owner_name}</td>
                                    <td className="p-4 text-center">
                                        <span className={`px-3 py-1 rounded-full text-[10px] font-bold ${owner.classification === 'खातेदार' ? 'bg-purple-100 text-purple-700 border border-purple-200' : 'bg-blue-100 text-blue-700 border border-blue-200'}`}>
                                            {owner.classification}
                                        </span>
                                    </td>
                                    <td className="p-4 text-center font-bold text-gray-600">{owner.familyCount}</td>
                                    <td className="p-4 text-center text-gray-400 text-xs italic">ड्रॉ ची प्रतीक्षा...</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* RESULTS TABLE */}
            {isDrawActive && (
                <div className="bg-white rounded-xl shadow-lg border border-green-200 overflow-hidden mb-8">
                    <div className="bg-green-50 p-4 border-b border-green-200 font-bold text-green-800">
                        ड्रॉ निकाल (Draw Results)
                    </div>
                    <table className="w-full text-left">
                        <thead className="bg-green-100 text-green-700 text-xs uppercase">
                            <tr>
                                <th className="p-4">नाव</th>
                                <th className="p-4 text-center">वर्गीकरण</th>
                                <th className="p-4 text-center">मिळालेला भूखंड</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-green-50">
                            {currentAreaAllocations.map((alloc) => (
                                <tr key={alloc.land_owner_id}>
                                    <td className="p-4 font-bold">{alloc.owner_name}</td>
                                    <td className="p-4 text-center">
                                        <span className="bg-white px-2 py-1 rounded border text-[10px] font-bold">{alloc.classification}</span>
                                    </td>
                                    <td className="p-4 text-center font-black text-xl text-blue-700">भूखंड क्र. {alloc.assignedPlot?.plot_no}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Footer Buttons */}
            <div className="flex gap-4 bg-white p-4 rounded-xl shadow-lg border sticky bottom-4">
                {!isDrawActive ? (
                    <button
                        onClick={runLuckyDraw}
                        disabled={!hasEnoughPlotsSelected || currentAreaOwners.length === 0}
                        className="flex-1 bg-blue-600 text-white py-4 rounded-xl font-bold flex justify-center items-center gap-2 disabled:opacity-50"
                    >
                        {isDrawing ? <RefreshCw className="animate-spin" /> : <Shuffle />} ड्रॉ सुरु करा
                    </button>
                ) : (
                    <>
                        <button onClick={() => setAllocations([])} className="bg-gray-200 text-gray-700 px-6 py-4 rounded-xl font-bold flex items-center gap-2"><Trash2 size={20}/> रद्द</button>
                        <button onClick={handleSaveAllocations} className="flex-1 bg-green-600 text-white py-4 rounded-xl font-bold flex justify-center items-center gap-2 shadow-xl animate-pulse"><Save /> वाटप जतन करा</button>
                    </>
                )}
            </div>
        </div>
    );
};

export default PlotLuckyDraw;